<template>
  <v-container>
    <v-row
      align="start"
      justify="start"
    >
      <v-col xs="12" md="6">
          <div v-if="showCasePage === 'showcase'">
            <ShowcasePage />
          </div>
          <div v-if="showCasePage === 'import'">
            <Import />
          </div>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ShowcasePage from '@/components/ShowcasePage'
import Import from '@/components/Import'

export default {
  name: 'Showcase',
  methods: {
    ...mapMutations([
      'setShowCasePage'
    ])
  },
  components: {
    ShowcasePage,
    Import
  },
  computed: {
    ...mapState({
      showCasePage: ({ config }) => config.showCasePage
    })
  }
}
</script>

<style>

</style>
